import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface MiscellaneousFunctionsState {
    processlist?:any,
    ramusage?:any,
    RemoteAccessResult?:any,
    sqlavailable?:any,
}
  
const initialState:MiscellaneousFunctionsState = {
    processlist:[],
    ramusage:[],
    RemoteAccessResult:[],
    sqlavailable:[],
}

export const MiscellaneousFunctionsSlice = createSlice({
    name:"miscellaneousList",
    initialState,
    reducers:{
        UpdateMiscellaneousFunctions: (state,action) => {
            state.processlist = action.payload.processlist;
            state.ramusage = action.payload.ramusage;
            state.RemoteAccessResult = action.payload.RemoteAccessResult;
            state.sqlavailable = action.payload.sqlavailable;
        },
        AddMiscellaneousFunctions: (state,action) => (
            initialState
        ),
        EditMiscellaneousFunctions: (state,action) => (
            initialState
       ),
        RemoveMiscellaneousFunctions: (state,action) => (
            initialState
        )
    }
})

export const {UpdateMiscellaneousFunctions,AddMiscellaneousFunctions,EditMiscellaneousFunctions,RemoveMiscellaneousFunctions} = MiscellaneousFunctionsSlice.actions

export const selectMiscellaneousFunctions = (state: RootState) => state.miscellaneousList

export default MiscellaneousFunctionsSlice.reducer;